import { type Country, type CountryVariantTemplate } from '@capsicum/common';
import { type ReactNode } from 'react';

import { Image } from '../../../atoms';

import { CountryCodeWrapper, FlagWrapper } from './components.styled';

export const GetCountryFlag = ({ iconSize, item }: { iconSize: number; item?: Country }): ReactNode => {
	const countryFlagImageURL = item?.images?.find(coutryImages => coutryImages.entityName === 'country')?.url;

	return (
		<FlagWrapper>
			{countryFlagImageURL && (
				<Image alt={`${item?.name}-flag`} height={iconSize} src={countryFlagImageURL} width={iconSize} />
			)}
		</FlagWrapper>
	);
};

const GetCountryWithFlag = ({
	afterFlagText,
	iconSize = 20,
	item
}: {
	afterFlagText?: string;
	iconSize?: number;
	item?: Country;
}): ReactNode => (
	<CountryCodeWrapper>
		<GetCountryFlag iconSize={iconSize} item={item} />
		{afterFlagText}
	</CountryCodeWrapper>
);

export const BaseCountrySelectTemplate = ({
	item,
	variant
}: {
	item: Country;
	variant: CountryVariantTemplate;
}): ReactNode => {
	return variant === 'country' ? (
		`${item.name}`
	) : variant === 'countryWithCode' ? (
		`${item.internationalCallingCode} (${item.name})`
	) : (
		<GetCountryWithFlag
			afterFlagText={
				variant === 'countryWithCodeAndFlag' ? `${item?.internationalCallingCode} (${item?.name})` : item?.name
			}
			item={item}
		/>
	);
};
